import { LiveParticipant } from '@shared/models/live';

/** Null when nobody held the stream. Returns new references so signal consumers behind an
 * Object.is cutoff see the change: `streamId` is what marks a participant as audible. */
export function withStreamCleared(participants: readonly LiveParticipant[], streamId: string): LiveParticipant[] | null {
  if (!participants.some((p) => p.streamId === streamId)) {
    return null;
  }
  return participants.map((p) => (p.streamId === streamId ? { ...p, streamId: undefined } : p));
}
